var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

(function ($, global, google) {
    'use strict';

    var typeLookup = {
        1: 'line',
        2: 'map',
        3: 'bar',
        4: 'pie',
        5: 'table',
        12: 'tableWithMoment',
        6: 'map_pc',
        7: 'radialGauge',
        16: 'linearGauge',
        8: 'radar',
        9: 'waterfall',
        //10: 'waterfall',
        10: 'horizontalWaterfall',
        11: 'funnel',
        13: 'tableau',
        14: 'tableExtended',
        15: 'stackedBars',
        17: 'rangeBars',
        18: 'bubble',
        19: 'stockChart',
        25: 'dpnFlash',
        26: 'dpnFlash2',
        27: 'dpnFlash5',
        28: 'dpnFlash8',
        29: 'custom_bars',
        30: 'label',
        32: 'text',
        31: 'barsAndLines',
        33: 'iconWithText',
        34: 'cssGauge',
        35: 'linksTable',
        36: 'progressGauge',
        37: 'tickerTape',
        38: 'tree',
        39: 'chord',
        40: 'videoMedia',
        41: 'imageMedia',
        43: 'audioMedia',
        42: 'sunburst',
        44: 'bilevel',
        45: 'area',
        46: 'pivotGrid',
        47: 'google_maps'
    };

    // google visualisation loader
    $.extend(MDB.Charts, {
        pieRawValueFormat: 'rawValue',
        dateFilterFormat: 'YYYY-MM-DD',
        dateFilterInputFormat: 'DD-MM-YYYY',

        ChartTypeNumbers: typeLookup,
        // options.dateFormat = MDB.Charts.dateFilterInputFormat;
        //     dateStart = moment(dateStart, options.dateFormat).format(MDB.Charts.dateFilterFormat);
        //     dateEnd = moment(dateEnd, options.dateFormat).format(MDB.Charts.dateFilterFormat);
        refreshAllWidgets: function () {
            var d = new $.Deferred();
            
            // reload each widget
            var promises = $('.widget').mdbRefreshWidget();
            $.when.apply($, promises)
                .done(function () {
                    d.resolve(); 
                })
                .fail(function () {
                    d.reject(); 
                })
                .always(function () {
                    // operation completed
                    $(document).trigger('mdbDashboard.reloaded');
                });
            return d.promise();
        },
        toggleWidgetInfo: function(e) {
            var me = $(e), 
            widget = me.closest('.widget'), 
            chart = widget.find('.chart');
            
            var id = e.id.split('_')[1];
            var info = $('#info_' + id);
            
            if (info.hasClass('collapse')) {
                info.removeClass('collapse');
                $('#' + e.id).text(MDB.loadResourceString('DashBoard_Index_Widget_Hide_Info_Text'));
            } else {
                info.addClass('collapse');
                $('#' + e.id).text(MDB.loadResourceString('DashBoard_Index_Widget_Show_Info_Text'));
            }

            chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget));
        },
        getWidgetDashboardFilterIds: function(widget){
            var filters = widget.data('dashboardfilters');
            if(!filters){
                filters = [];
            }
            
            if(!_.isArray(filters)){
                filters = filters.split(';');
            }
            
            return filters;
        },
        rescaleAllWidgets: function () {
            var widgets = $('.widget');
            var containerWidth = $('.widget-container-v2-autolayout').width();
            
            //First: reset all widget proportions
            if (MDB.Charts.useAutoLayout){
                widgets.each(function () {
                    var widget = $(this);
                    var boxPrimary = widget.find('.box-primary');
                    var boxPrimaryOriginalSize = boxPrimary.data('originalSize');
					
                    //Since we overwrite the width/height, reset them prior to rescaling
                    if (boxPrimaryOriginalSize){
                        boxPrimary.height(boxPrimaryOriginalSize.height);
                        boxPrimary.width(boxPrimaryOriginalSize.width);
						
                        widget.height(MDB.Charts.calculateKendoChartContainerHeight(widget));
                        widget.width('');
                    }
                });
            }
            //Then redraw the the widgets
            widgets.each(function () {
                $(this).data('reload')(true);
            });
            
            var rowWidth = 0;
            
            var widgetRows = [];
            var currentRowIndex = 0;
            var getPxRegex = /(\d+)px/;
            
            //Attempt to divide widgets into rows based on known widths
            _.forEach(widgets, function (widget) {
                widget = $(widget);
                var widgetWidth = widget.width();
                rowWidth += widgetWidth;
                
                if (rowWidth > containerWidth) {
                    rowWidth = widgetWidth;
                    currentRowIndex += 1;
                }
                
                if (!widgetRows[currentRowIndex]) {
                    widgetRows[currentRowIndex] = [];
                }

                widgetRows[currentRowIndex].push(widget);
            });
            
            _.forEach(widgetRows, function (row) {
                if (!row.length) {
                    return;
                }
                
                var maxHeight = _.max(_.map(row, function (widget) {
                    return widget.height() ;
                }));
                var extraWidthPerWidget = _.sum(_.concat(containerWidth, _.map(row, function (widget) {
                    var computedStyle = window.getComputedStyle(widget[0]);
                    
                    //Calculate both left/right margins so we can add those to the total width
                    var margin = _.sum(_.map([getPxRegex.exec(computedStyle.marginLeft), getPxRegex.exec(computedStyle.marginRight)], function (marginRes) { 
                        return marginRes.length > 1 ? parseInt(marginRes[1]) : 0; 
                    }));
                    
                    return -(widget.outerWidth() + margin);
                })));
                
                extraWidthPerWidget = Math.floor(extraWidthPerWidget / row.length);
                
                _.forEach(row, function (widget) {
                    var box = widget.find('.box-primary');
                    box.height(maxHeight);
                    widget.height(maxHeight);

                    var fullWidth = widget.width() + extraWidthPerWidget;
                    box.width(fullWidth);
                    widget.width(fullWidth);
                });
            });
        },
        refreshAllWidgetsWithDashboardFilter: function (attributeId) {
            // reload each widget that use the specified dashboard filter
            $('.widget[data-dashboardfilters*="' + attributeId + '"]').mdbRefreshWidget();
        },
        refreshAllWidgetsWithDashboardFilters: function(attributeIds){
            //A single widget can have multiple attributes, we only want to refresh each widget once
            var attributeSelectors = attributeIds.map(function(attributeId){
                return '.widget[data-dashboardfilters*="' + attributeId + '"]';
            }).join(',');
            
            return $(attributeSelectors).mdbRefreshWidget();
        }
    });
    $.fn.mdbRefreshWidget = function () {
        var promises = [];
        this.filter('.widget').each(function () {
            // reload widget
            var widget = $(this);
            var reload = widget.data('reload');
            if (reload && typeof (reload) === 'function') {
                // widget.find('.chart').empty();
                // widget.find('.loading-box').show();
                var p = reload();
                // if it looks like a promise, swims like a promise, and quacks like a promise, then it probably is a promise.
                if(p && p.done) {
                    promises.push(p);

                    widget.addClass('widget-loading');
                    p.done(function () {
                        widget.removeClass('widget-loading');
                    });
                }
            }
        });
        return promises;
    };
    
    $.extend(MDB.Charts, {
        dateStart: false,
        dateEnd: false,
        divisionId: null,

        registerFunctions: function (widget, id, type, config) {
            var renderTitleOptions = function() {
                var config = widget.data('config') || {};
                var titleOpts = config.titleOpts;
                if (titleOpts && titleOpts.centered) {
                    widget.find('.widget-header').addClass('text-center');
                }
                
                //if(config.htmlAttributes && Object.keys && [].forEach) {
                //	Object.keys(config.htmlAttributes).forEach(function(item) {
                //		// set custom attribute
                //		widget.attr(item, config.htmlAttributes[item] || '');
                //	});
                //}
            };

            var showMessage = function (message, additionalLines) {
                widget.find('.loading-box').hide();
                var chart = widget.find('.chart');
                chart.show().find('.no-data-message').remove();
			    var messageContainer = $('<div />', { 'class': 'no-data-message info' }).text(message);
                if (additionalLines && additionalLines.join) {
                    $('<div />', { css: { 'white-space': 'pre-wrap' } })
                    	.text(additionalLines.join('\n'))
                    	.appendTo(messageContainer);
                }
                messageContainer.appendTo(chart);
            };
            
            var getCustomMessages = function(){
                // NoDataErrorMessage
                // FailedToGetDataErrorMessage
                // CustomMessageColumnName
                
                var config = widget.data('config');
                return config && config.CustomMessages || {};
            };
            
            var getNoDataErrorMessageText = function() {
                return getCustomMessages().NoDataErrorMessage || MDB.loadResourceString('Chart_ErrorMessage_NoData');
            };
            
            var getFailedToGetDataErrorMessage = function() {
                return getCustomMessages().FailedToGetDataErrorMessage || MDB.loadResourceString('Chart_ErrorMessage_FailedToGetData');
            };
            
            var getMessageFromData = function(data){
                var customMessageColumnName = getCustomMessages().DataMessageColumnName;
                
                if(!customMessageColumnName || !data || !data[0]) {
                    return undefined;
                }

                //Simply return the column value of the first encountered data object
                return data[0][customMessageColumnName];
            };
            
            var emptyChartForRender = function(){
                //DPN flash widget widgets are special cases
                //so their renderer adds a 'dont-empty-on-reload' value to the dataset
                if (widget.data('dont-empty-on-reload') !== true) {
                    widget.find('.chart').empty(); //.hide();
                }
            };
            
            var renderData = function (data, dataSecondary) {
                var d = new $.Deferred();
                // fill widget
                // got data: [{ "Column1": 1, "Name": "Widget T1" }]
                // convention: first column = value, 2nd column = 5
                var chart = widget.find('.chart');
                //var info = widget.find('.widget-info');
                var renderer = typeLookup[type];
                var metadata;
                renderer = MDB.Charts.renderers[renderer];
                if (!renderer) {

                    console.warn('Unknown chart type: ' + type);
                    return;
                }
                chart.removeClass('tablewidget');

                emptyChartForRender();
                
                if(data && data.length){
                    metadata = data.metadata;
                } else{
                    showMessage(getNoDataErrorMessageText());
                    metadata = undefined;
                }

                var customMessage = getMessageFromData(data);
                
                if(customMessage){
                    //When a message is defined and provided; we just want to display the message instead of rendering our widget
                    showMessage(customMessage);
                } else{
                    renderer(widget, chart, data, metadata, dataSecondary || {});   
                }
				
				
                // if (widget.data('hasBottomInfo') === 'True'){
				 //   
				 //    widget.find('.box-primary').css({'height': ''});
                // } 
				
                d.resolve();

                return d.promise();
            };
			
            // (re)load the widget data
            var reload = function (isRedraw) {
			    renderTitleOptions();
			    
                if (id === 'preview') {
                    // do nothing for preview
                    var d = new $.Deferred();
                    d.resolve($.noop);
                    return d.promise();
                }
                
                if (MDB.Charts.useAutoLayout && isRedraw){
                    //Scale widget
                    var boxPrim = widget.find('.box-primary');
                    var chart = widget.find('.chart');
                    
                    boxPrim.data('originalSize', {
                        height: boxPrim.height(),
                        width: boxPrim.width()
                    });
                    
                    //Height calculations are based on box primary's height
                    boxPrim.height(Math.max(widget.data('autoMinHeight') || 0, boxPrim.height()));

                    widget.height(boxPrim.height());
                    chart.height(MDB.Charts.calculateKendoChartContainerHeight(widget));
                    
                    var aspectRatio = widget.data('autoAspectRatio') || 1;

                    boxPrim.width(MDB.Charts.calculateKendoChartContainerHeight(widget) * aspectRatio);
                }


                if (isRedraw){
                    var kChart = widget.find('.k-chart');
                    if(kChart.length){
                        kChart.data('kendoChart').redraw();
                    }

                    return $.Deferred().resolve().promise();
                }
                
                var currentDeferred = widget.data('loadDataDeferred');
                if(currentDeferred){
                    currentDeferred.reject(null, 'aborted');
                    widget.data('loadDataDeferred', null);
                }
                

                var promises = [];
                var kConfig = widget.data('kendo-config');
                
                if (!kConfig || !kConfig.bodyless) {
                    var promise1 = MDB.loadWidgetData(id, MDB.Charts.dateStart, MDB.Charts.dateEnd, MDB.Charts.divisionId);
                    promises.push(promise1);
                    if (MDB.Charts.dateStartSecondary && type === 1 &&
                        MDB.Charts.dateStartSecondary !== 'Invalid date' &&
                        MDB.Charts.dateEndSecondary !== 'Invalid date' &&
                        widget.data('datefilter') === 'True') {
                        var promise2 = MDB.loadWidgetData(id, MDB.Charts.dateStartSecondary, MDB.Charts.dateEndSecondary, MDB.Charts.divisionId);
                        promises.push(promise2);
                    }
                } else {
                    var p = $.Deferred();
                    
                    //Mimic a regular response by containing a truthy 'length' property
                    //if we don't contain a length property; our renderer will crash
                    p.resolve({ metadata: { KendoConfig: kConfig }, length: 1 });
                    promises.push(p.promise());
                }


                var promissesDeferred = $.when.apply($, promises);
                
                var compoundDeferred = $.Deferred(function(deferred){
                    //Simply proxy the calls, we just want control over the deferred's state
                    promissesDeferred.done(function(){
                        deferred.resolve.apply(deferred, arguments); 
                    });
                    promissesDeferred.fail(function(){
                        deferred.reject.apply(deferred, arguments);
                    });
                });
                
                var compoundDeferredProm = compoundDeferred.promise()
                    .fail(function mdb_charts_register_reload_fail(xhr, status) {
                        emptyChartForRender();
                        
                        if(!xhr && status === 'aborted'){
                            return;
                        }
                        
                        if (status === 'error' && xhr && xhr.responseText && console.error) {
                            console.error('Fout bij het ophalen van de gegevens voor de widget: ' + id + '\r\n ' + xhr.responseText);
                        }
                        
                        showMessage(getFailedToGetDataErrorMessage(), xhr);
                    })
                    .done(renderData);

                widget.data('loadDataDeferred', compoundDeferred);
                    
                return compoundDeferredProm;
            };

            widget.data('renderdata', renderData);
            widget.data('reload', reload);
            
            widget.on('click', '.enhanced-export', function () {
                MDB.Charts.exportWidget(widget.data('id'), true);  
            });
        },

        // renderers: { },
        
        exportWidget: function (widgetId, isEnhancedExport) {
            var divisionId = MDB.Charts.divisionId;
            divisionId = MDB.isGuid(divisionId) ? divisionId : null;
            isEnhancedExport = isEnhancedExport || false;
            
            var data = {
                widgetId: widgetId,
                start: MDB.Charts.dateStart,
                end: MDB.Charts.dateEnd,
                divisionId: divisionId,
                isEnhanced: isEnhancedExport,
                dashboardFilters: JSON.stringify(MDB.Charts.getArraySerializedFilters())
            };

            window.location.href = '/Widget/Download?' + $.param(data);
        },
        convertApiToKendo: function (data, widget, metadata, secondaryData) {
            if (data.length === 0) {
                return {};
            }

            var aliasses = {};
            if (widget && widget.data) {
                try {
                    var tmp = widget.data('titles');
                    if (tmp) {
                        tmp = JSON.parse(tmp);
                    }
                    if (tmp) {
                        aliasses = tmp;
                    }
                } catch (e) {
                    console.error('Error parsing widget aliasses');
                    console.error(e.stack);
                }
            }

            var useLegacyKeyTransform = metadata && metadata.KendoConfig && metadata.KendoConfig._UseLegacyKeyTransformation;

            var keyMappings = MDB.Charts.transformKeysToKendoFields(data, useLegacyKeyTransform);
            var keys = MDB.Charts.getDataKeys(data[0]);
            var series1 = [];
            var cats1 = {};
            var series = [];
            var cats = [];
            for (var i = 1; i < keys.length; i++) {
                var originalKey = keyMappings.findByKey(keys[i]).originalKey;
                var name = aliasses[originalKey] || originalKey;
                
                
                if (secondaryData && secondaryData.length) {
                    series1.push(
                        {
                            name: name + ' (' + MDB.Charts.dateStart + ' / ' + MDB.Charts.dateEnd + ')',
                            field: keys[i],
                            data: secondaryData,
                            tooltip: MDB.KendoConfigBuilder.multiDateSeriesTooltip(keys[0], name)
                        });
                    series1.push(
                        {
                            name: name + ' (' + MDB.Charts.dateStartSecondary + ' / ' + MDB.Charts.dateEndSecondary + ')',
                            field: keys[i],
                            data: data,
                            tooltip: MDB.KendoConfigBuilder.multiDateSeriesTooltip(keys[0], name)
                        });
                } else {
                    series1.push({
                        name: name,
                        field: keys[i],
                        data: data,
                        tooltip: MDB.KendoConfigBuilder.singleSeriesTooltip(name)
                    });
                }
                
                series.push({
                    name: name,
                    data: []
                });
            }

            cats1.field = keys[0];

            var keyValueConverter = null;
            if (data.length > 0 && keys.length > 0 && data[0][keys[0]]) {
                // detect timestamps and convert to a date object (format: "2014-12-03T00:00:00")
                if (/\d{4}\-\d{2}\-\d{2}T\d{2}:\d{2}:\d{2}.*/.test(data[0][keys[0]])) {
                    keyValueConverter = function (value) {
                        if (value) {
                            value = new Date(value);
                        }
                        return value;
                    };
                }
            }

            data.forEach(function (value) {
                var i;
                for (i = 0; i < 1 && i < keys.length; i++) {
                    if (keyValueConverter && i === 0) {
                        value[keys[i]] = keyValueConverter(value[keys[i]]);
                    }
                    cats.push(value[keys[i]]);
                }
                for (i = 1; i < keys.length; i++) {
                    series[i - 1].data.push(value[keys[i]]);
                }
            });

            if (secondaryData && secondaryData.length) {
                secondaryData.forEach(function (value) {
                    var i;
                    for (i = 0; i < 1 && i < keys.length; i++) {
                        if (keyValueConverter && i === 0) {
                            value[keys[i]] = keyValueConverter(value[keys[i]]);
                        }
                    }
                });
            }
            
            return {
                categoryAxis: cats,
                categoryAxis1: cats1,
                series: series,
                series1: series1,
                data1: data
            };
        },
        convertApiToKendoPieChart: function(data, widget) {
            if (data.length === 0) {
                return {};
            }

            var keys = MDB.Charts.getDataKeys(data[0]);
            var colorKey = MDB.Charts.getDataColorKey(data[0]);
            
            var series = [];

            data.forEach(function (value) {
                for (var i = 1; i < 2 && i < keys.length; i++){
                    var obj = {
                        category: value[keys[0]], //keys[i],
                        value: value[keys[i]]
                    };
                    
                    if (colorKey) {
                        obj[colorKey] = value[colorKey];
                    }
                    
                    series.push(obj);
                }
            });
            return {
                series: [{
                    type: 'pie',
                    data: series
                }]
            };
        },
        calculateKendoChartInfoHeight: function(widget){
            return widget.find('.widget-info').outerHeight();
        },
        /**
         * Calculate the maximum height in pixels that the chart can use
         */
        calculateKendoChartContainerHeight: function (widget) {
            var containerHeight = widget.find('.box-primary').outerHeight(),
                headerHeight = widget.find('.box-header').outerHeight(),
                resizeAnchorHeight = widget.find('.ui-resizable-se').height();

            return (containerHeight + 0) - headerHeight - resizeAnchorHeight;
        },
        calculateKendoChartMaxHeight: function (widget) {
            var height = MDB.Charts.calculateKendoChartContainerHeight(widget);
            var infoHeight = MDB.Charts.calculateKendoChartInfoHeight(widget);
            
            return height > 0 ? (height - infoHeight) : widget.find('.chart').width() / 2;
        },
        calculateKendoChartMaxWidth: function (widget) {
            var containerWidth = widget.find('.box-primary').outerWidth(),
                headerWidth = widget.find('.box-header').outerWidth(),
                resizeAnchorWidth = widget.find('.ui-resizable-se').width();

            var width = containerWidth - headerWidth - resizeAnchorWidth;
            return width > 0 ? width : widget.find('.chart').width() / 2;
        },
        generateKendoChartConfig: function (data, seriesDefaults, widget, metadata, secondaryData) {
            if (seriesDefaults && seriesDefaults.type === 'line') {
                return this.generateKendoLineChartConfig(data, seriesDefaults, widget, metadata, secondaryData);
            }
            try {
                data = MDB.Charts.convertApiToKendo(data, widget);
                var cfg = {
                    title: {
                        text: ''
                    },
                    legend: {
                        position: 'bottom'
                    },
                    chartArea: {
                        background: '',
                        height: MDB.Charts.calculateKendoChartMaxHeight(widget)
                    },
                    seriesDefaults: seriesDefaults,

                    series: data.series,
                    valueAxis: {
                        labels: {
                            format: '{0}'
                        },
                        line: {
                            visible: false
                        },
                        axisCrossingValue: -10
                    },
                    categoryAxis: {
                        categories: data.categoryAxis,
                        // baseUnit: "fit",
                        majorGridLines: {
                            visible: false
                        }
                    },
                    tooltip: {
                        visible: true,
                        format: '{0}%',
                        template: MDB.Charts.combineWithDefaultTooltipTemplate(' #= value #')
                    }
                };

                MDB.Charts.initializeLegendClickHandler(cfg);


                return cfg;
            } catch (e) {
                console.error('Error generating configuration');
                console.log(e.stack);
                console.error(e);
            }
        },

        generateKendoLineChartConfig: function (data, seriesDefaults, widget, metadata, secondaryData) {
            try {
                data = MDB.Charts.convertApiToKendo(data, widget, metadata, secondaryData);
                var multipleTimespans = secondaryData && secondaryData.length;
                var cfg = {
                    dataBound: function (e) {
                        /*
                        // reduce the step count based upon the amount of data points
                        var chart = widget.find('.chart').data("kendoChart");
                        if (!chart) return;

                        var sd = seriesData.view();
                        if (sd.length > 100)
                            chart.options.categoryAxis.labels.step = 10;
                        else
                            chart.options.categoryAxis.labels.step = 1;
                        */
                    },
                    title: {
                        text: ''
                    },
                    legend: {
                        position: 'bottom'
                    },
                    chartArea: {
                        background: '',
                        height: MDB.Charts.calculateKendoChartMaxHeight(widget)
                    },
                    seriesDefaults: seriesDefaults,
                    series: data.series1,
                    valueAxis: {
                        labels: {
                            format: '{0}'
                        },
                        line: {
                            visible: false
                        },
                        axisCrossingValue: -10
                    },
                    categoryAxis: {
                        categories: data.categoryAxis,
                        baseUnit: 'fit',
                        baseUnitStep: 'auto',
                        labels: {
                            rotation: -45
                        }
                    }
                };
                
                if(!multipleTimespans){
                    MDB.Charts.setCategoryAxisWeekDisplayToWeekNumbers(cfg);
                }
                
                // Only show the day of the week for multiple timespans.
                if (multipleTimespans) {
                    cfg.categoryAxis.baseUnit = 'days';
                    cfg.categoryAxis.baseUnitStep = 1;
                    cfg.categoryAxis.labels.template = '#= kendo.toString(value, "dddd") #';
                }
                
                return cfg;
            } catch (e) {
                console.error('Error generating configuration');
                console.log(e.stack);
                console.error(e);
            }
        },

        generateKendoPieChartConfig: function (data, metadata, widget) {
            data = MDB.Charts.convertApiToKendoPieChart(data, widget);
            var kendoConfig = metadata.KendoConfig || {};

            var applyAdditionalTemplateFormatting = function (target, template) {
                //Attempt to apply desired formatting
                template = template || sprintf("#= kendo.format('%s', percentage)#", target.format || '{0:P}');
                
                if (target.format === MDB.Charts.pieRawValueFormat) {
                    template = '#= value#';
                }
                
                template = '#= category #: ' + template;

                return template;
            };
            
            var series = data.series;
            var singleSeries =  series[0];

            var cfg = {
                title: {
                    text: ''
                },
                legend: { position: 'top' },
                seriesDefaults: {
                    labels: {
                        visible: false,
                        position: 'outsideEnd',
                        background: 'transparent'
                    }
                },
                series: series,
                tooltip: {
                    visible: true,
                    template: "#= kendo.format('{0:P}', percentage)#"
                }
            };
            
            if (kendoConfig) {
                $.extend(true, cfg, kendoConfig); 
            }
            if (metadata.Colors && metadata.Colors.length > 0) {
                cfg.seriesColors = metadata.Colors;
            }

            var keys = _.keys(singleSeries.data[0]);
            
            var formatableValues = MDB.Charts.getAggregatedFormatableValues(singleSeries.data, keys);
            
            MDB.Charts.setLabelFormat(singleSeries, cfg.seriesDefaults, function () {
                return formatableValues; 
            }, 'value', undefined, applyAdditionalTemplateFormatting);
            MDB.Charts.setLabelFormat(singleSeries, [cfg.seriesDefaults, cfg], function () {
                return formatableValues; 
            }, 'value', 'tooltip', applyAdditionalTemplateFormatting);
            
            MDB.Charts.initializeLegendClickHandler(cfg, function (visibleItems) {
                var visibleCategories = _.map(visibleItems, 'category');
                
                formatableValues = MDB.Charts.getAggregatedFormatableValues(_.filter(singleSeries.data, function (dataItem) {
                    return visibleCategories.indexOf(dataItem.category) !== -1;
                }), keys);
            });
            
            return cfg;
        },

        getKendoConfigValue: function(metadata, name) {
            if (metadata && metadata.kendoConfig) {
                return metadata.kendoConfig[name];
            }
            return undefined;
        }

    });

    /* 
        LEGACY RENDERER
        
        New renderer is defined in marketingdb-graphs-table.js 
    */
    // MDB.Charts.renderers.table = function (widget, chart, data) {
    //     // got data: [{ "Column1": 1, "Name": "Widget T1" }]
    //     // convention: first column = value, 2nd column = 5
    //     if (!data || data.length === 0) {
    //         widget.find('.loading-box').hide();
    //         return;
    //     }
    //     setTimeout(function () {
    //         MDB.Charts.emptyChartAndMakeVisible(widget, chart);
    //
    //         if (!chart.hasClass('tablewidget')) {
    //             chart.addClass('tablewidget');
    //         }
    //         var tbl = MDB.Charts.generateKendoTable(data, widget);
    //         chart.append(tbl);
    //     }, 0);
    // };

    // line chart
    MDB.Charts.renderers.line = function (widget, chart, data, metadata, secondaryData) {
        // got data: [{ "Column1": 1, "Name": "Widget T1" }]
        // convention: first column = value, 2nd column = 5
        if (!data || data.length === 0) {
            widget.find('.loading-box').hide();
            return;
        }
        
        setTimeout(function () {
            MDB.Charts.emptyChartAndMakeVisible(widget, chart);
            
            var container = $('<div class="line">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });
            var kendoConfig = MDB.Charts.generateKendoChartConfig(data, {
                type: 'line',
                style: 'smooth'
            }, widget, metadata, secondaryData);

            if (metadata.Colors && metadata.Colors.length > 0) {
                cfg.seriesColors = metadata.Colors;
            }
            // load custom kendo configuration options
            var widgetConfig = widget.data('config');
            if(typeof widgetConfig === 'string') {
                widgetConfig = JSON.parse(widgetConfig);
            }

            if (widgetConfig && widgetConfig.kendoOpts) {
                $.extend(true, kendoConfig, widgetConfig.kendoOpts);
            }
            if(metadata.KendoConfig) {
                $.extend(true, kendoConfig, metadata.KendoConfig);
            }

            MDB.Charts.initializeLegendClickHandler(kendoConfig);

            //We set axisCrossingValue to -10 by default without any way to configure it;
            //when axisCrossingValue is present, 'log' requires it to be positive or it does not render
            if(kendoConfig.valueAxis && kendoConfig.valueAxis.type === 'log' && kendoConfig.valueAxis.hasOwnProperty('axisCrossingValue')){
                delete kendoConfig.valueAxis.axisCrossingValue;
            }
            
            chart.append(container);
            container.kendoChart(kendoConfig);
        }, 0);

    };
    MDB.Charts.renderers.bar = function (widget, chart, data, metadata) {
        // got data: [{ "Column1": 1, "Name": "Widget T1" }]
        // convention: first column = value, 2nd column = 5
        if (!data || data.length === 0) {
            widget.find('.loading-box').hide();
            return;
        }

        setTimeout(function () {
            MDB.Charts.emptyChartAndMakeVisible(widget, chart);
            //chart.height('500px')
            var container = $('<div class="bar">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });
            var kendoConfig = MDB.Charts.generateKendoChartConfig(data, { type: 'column' }, widget);

            kendoConfig.categoryAxis = {
                categories: kendoConfig.categoryAxis.categories,
                labels: { padding: { top: 0 }, format: '{0}', rotation: -45 },
                line: { visible: false }
                //, baseUnitStep: "auto"
            };

            kendoConfig.valueAxis = {
                labels: { format: '{0}' },
                line: { visible: false },
                axisCrossingValue: 0
            };

            // load custom kendo configuration options
            var widgetConfig = widget.data('config');
            if (widgetConfig && widgetConfig.kendoOpts) {
                $.extend(true, kendoConfig, widgetConfig.kendoOpts);
            }


            if (kendoConfig.categoryAxis.categories.length > 0 && kendoConfig.categoryAxis.categories[0] instanceof Date) {
                kendoConfig.categoryAxis.labels.template = "#= value.toLocaleDateString('nl-NL') #";
            }
            if (metadata.Colors && metadata.Colors.length > 0) {
                cfg.seriesColors = metadata.Colors;
            }

            if (metadata.KendoConfig) {
                $.extend(true, kendoConfig, metadata.KendoConfig);
            }

            chart.append(container);
            container.kendoChart(kendoConfig);
        }, 0);
    };

    // pie chart
    MDB.Charts.renderers.pie = function (widget, chart, data, metadata) {
        if (!data || data.length === 0) {
            return;
        }

        setTimeout(function () {
            MDB.Charts.emptyChartAndMakeVisible(widget, chart);
            chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget));
            
            var container = $('<div class="pie">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });
            var kendoConfig = MDB.Charts.generateKendoPieChartConfig(data, metadata, widget);
            if(metadata.KendoConfig) {
                $.extend(true, kendoConfig, metadata.KendoConfig);
            }

            if (kendoConfig.backgroundMediaId){
                kendoConfig.chartArea = {
                    background: 'transparent'
                };

                MDB.Charts.Media.generateUrl(kendoConfig.backgroundMediaId, function (url) {
                    container.css({
                        'background-image': 'url(' + url + ')',
                        'background-repeat': 'no-repeat',
                        'background-size': 'contain',
                        'background-position': 'center'
                    });
                });
            }
            
            chart.append(container);
            container.kendoChart(kendoConfig);
        }, 0);
    };

    //Empty renderer to prevent unknown renderer message
    MDB.Charts.renderers.label = $.noop;

    MDB.Charts.renderers.text = function(widget, chart, data, metadata) {
        var config = widget.data('config').kendoOpts || {},
            par, 
            initialized = !!widget.data('initialized');
        
        if(!initialized) {    
            widget.data('initialized', true);
            par = $('<p />', { 'class':'widget-text-container' });
            par.attr('style', config.css);
            widget.find('.widget-tooltip').addClass('no-tooltip');
            widget.find('.box-body').addClass('widget-text').empty().append(par);
        }
        
        var text = config.text;
        if(!text) {
            var values = data[0] ? _.values(data[0]) : [];
            if(values.length){
                text = values[0];
            }
        }
        
        par = widget.find('.box-body p.widget-text-container');
        par.text(text || '');
    };
})(jQuery, window, window.google);